module.exports = __webpack_public_path__ + "static/img/map2_relation.c0239e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map2_relation.jpg
// module id = aO1d
// module chunks = 1